import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MobileCenteredLayout } from '@/components/MobileCenteredLayout/MobileCenteredLayout';
import { OnboardingProgress } from '@/components/OnboardingProgress/OnboardingProgress';
import { WelcomeCta } from '@/components/WelcomeCta/WelcomeCta';
import { WelcomeFooter } from '@/components/WelcomeFooter/WelcomeFooter';
import { WelcomeHeadline } from '@/components/WelcomeHeadline/WelcomeHeadline';
import { trackWelcomeEvent } from '@/helpers/analytics';
import heroImg from '@/assets/onboarding/welcome-hero.webp';
import '@/Pages/Welcome/WelcomePage.sass';

export function WelcomePage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const document = searchParams.get('document') ?? undefined;

  useEffect(() => {
    void trackWelcomeEvent({ name: 'welcome_page_view' });
  }, []);

  return (
    <MobileCenteredLayout>
      <Box
        component="main"
        className="welcome-page"
        data-testid="welcome-page-main"
      >
        <Box className="welcome-page__hero" aria-hidden>
          <Box
            component="img"
            src={heroImg}
            alt=""
            className="welcome-page__hero-image"
          />
          <Box className="welcome-page__hero-fade" />
          <Box
            component="svg"
            className="welcome-page__hero-flow"
            viewBox="0 0 1200 300"
            preserveAspectRatio="none"
          >
            <path
              d="M-40,262 C160,206 330,288 530,244 C712,204 862,276 1046,240 C1130,224 1188,232 1240,226"
              fill="none"
              stroke="#D5F919"
              strokeWidth={26}
              strokeLinecap="round"
            />
          </Box>
        </Box>

        <Box className="welcome-page__content">
          <OnboardingProgress currentStep={1} />
          <WelcomeHeadline document={document} />
          <Box className="welcome-page__cta-wrapper">
            <WelcomeCta />
          </Box>
          <WelcomeFooter />
        </Box>
      </Box>
    </MobileCenteredLayout>
  );
}
